import React from 'react'

export const Icon = (props) => (
    <i className={`margin-r-5 ${props.icon || 'fa fa-meh-o'}`}></i>
)
